import { render, staticRenderFns } from "./reset-link-confirm-modal.vue?vue&type=template&id=a3302d8a&scoped=true"
import script from "./reset-link-confirm-modal.vue?vue&type=script&lang=js"
export * from "./reset-link-confirm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3302d8a",
  null
  
)

export default component.exports